import React from 'react';
import OurTestimonialsData from '../../../AppData/OurTestimonialsData';
import Section from '../../Section';
import SecondaryTitle from '../../Titles/SecondaryTitle';
import ThirdTitle from '../../Titles/ThirdTitle';
import RatingStars from '../../RatingStarts';

const OurTestimonials = () => {
  return (
    <Section className="bg-bg-cream py-12 sm:py-16 md:py-20 lg:py-24">
      <div className='max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-16'>

        {/* Header */}
        <div className='text-center mb-12 sm:mb-14 md:mb-16 lg:mb-20'>
          <span className='text-accent-gold text-xs sm:text-sm uppercase font-semibold tracking-widest'>Client Reviews</span>
          <SecondaryTitle
            title='What Our Clients Say'
            className='text-text-primary'
            animation='fade-up'
          />
          <div className='luxury-divider mx-auto'></div>
        </div>

        {/* Testimonials Grid - Column on Mobile, Row on LG+ */}
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 md:gap-10 lg:gap-12'>
          {OurTestimonialsData.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className='
                bg-white rounded-lg shadow-md
                p-5 sm:p-6 md:p-7
                flex flex-col justify-between
                hover:shadow-lg hover:shadow-accent-gold/20
                transition-all duration-300
                border border-accent-gold/10
                hover:border-accent-gold/30
              '
              data-aos='fade-up'
              data-aos-delay={index * 100}
            >

              {/* Client Title - At Top */}
              <p className='
                text-accent-gold
                font-semibold
                uppercase text-xs
                tracking-widest
                mb-1
              '>
                {testimonial.title}
              </p>

              {/* Quote Mark */}
              <p className='text-2xl sm:text-3xl text-accent-gold/20 mb-1 leading-none'>&#8220;</p>

              {/* Testimonial Text */}
              <p className='
                paragraph
                text-text-secondary
                text-sm sm:text-base md:text-base lg:text-base
                mb-2
                italic font-medium leading-snug
                flex-grow
              '>
                "{testimonial.description}"
              </p>

              {/* Stars */}
              <div className='mb-2'>
                <RatingStars rating={testimonial.stars} />
              </div>

              {/* Client Name - At Bottom */}
              <ThirdTitle
                title={testimonial.name}
                className='text-text-primary font-serif text-base sm:text-lg md:text-base lg:text-lg'
              />
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default OurTestimonials;
